// extracted by mini-css-extract-plugin
export default {"container":"SelectSegments_container__ScDql"};